module.exports = __webpack_public_path__ + "img/other_pay_oinpay.80f1f844.svg";